import React from "react";
import PropTypes from "prop-types";
import classes from "./AssignmentDateTimeFields.scss";

/**
 * Container component responsible for layout of date/time fields
 * Follows Single Responsibility Principle - only handles layout
 */
const DateTimeFieldsContainer = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};

DateTimeFieldsContainer.propTypes = {
  /** Child components to render */
  children: PropTypes.node,
};

DateTimeFieldsContainer.defaultProps = {
  children: null,
};

export default DateTimeFieldsContainer;
